import React from "react"
import Page from "../layout/page/Page"
import Panel from "../layout/panel/Panel"
import { Jumbo } from "../components/home/Welcome"
import PageTitle from "../layout/page/PageTitle"

const styles = {
  section: {
    marginBottom: 24
  },
  heading: {
    marginBottom: 8
  }
}

const Heading = () => {
  return (
    <Jumbo>
      <div style={{ height: 200 }}/>
    </Jumbo>
  )
}

const PrivacyPage = () => {
  return (<Page header={<Heading/>} className="full-width">
    <div className="container">
      <div style={{ margin: "-250px auto 0 auto", maxWidth: 800 }}>
        <PageTitle
          title={"Privacy & Support"}
          subtitle={"Chimp browser extension"}
        />
        <Panel bodyStyle={{ padding: "20px 40px" }}>

          <div style={styles.section}>
            <h4 style={styles.heading}>What we store</h4>
            <p>
              The Chimp extension only stores the recipes you create yourself — the small
              customization scripts used to personalize the websites you visit. Recipes are
              kept locally in your browser, and are only sent to our servers if you choose to
              sign in and sync them across your devices.
            </p>
          </div>

          <div style={styles.section}>
            <h4 style={styles.heading}>What we don't collect</h4>
            <p>
              We do not collect, store, or track any other information about you or your
              browsing activity. There is no analytics, no ad tracking, and no user
              profiling — the extension only ever reads and applies the recipes you've
              created on the pages you choose to enhance.
            </p>
          </div>

          <div style={styles.section}>
            <h4 style={styles.heading}>Sharing</h4>
            <p>
              Your recipes stay private by default. They are only shared with others if you
              explicitly choose to make a recipe public or share it with a team.
            </p>
          </div>

          <div style={styles.section}>
            <h4 style={styles.heading}>Your rights</h4>
            <p>
              You can view, edit, export, or delete any of your recipes at any time from your
              account, and make a shared recipe private again whenever you want.
            </p>
          </div>

          <div style={styles.section}>
            <h4 style={styles.heading}>Support</h4>
            <p>
              Questions or issues with the extension? Reach out to us through{" "}
              <a href="https://chimp.fr">chimp.fr</a>.
            </p>
          </div>

        </Panel>
      </div>
    </div>
  </Page>)
}

PrivacyPage.propTypes = {}
PrivacyPage.defaultProps = {}

export default PrivacyPage
